// extracted by mini-css-extract-plugin
module.exports = {"quantity-container":"quantity-selector_quantity-container__S2xOC"};